import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_PUBLIC_MANUAL_BILL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetPublicManualBillPayload,
  GetPublicManualBillResult,
  PublicManualBill,
} from '../types/getPublicManualBill.types';

const PUBLIC_MANUAL_BILL = 'PublicManualBill';

export const getPublicManualBill = (builder: BuilderType) =>
  builder.query<PublicManualBill, GetPublicManualBillPayload>({
    providesTags: [PUBLIC_MANUAL_BILL],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PAYMENTS_PUBLIC_MANUAL_BILL_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPublicManualBillResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.ManualBill;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
